import { isNotEmptyElement } from '@feedyou/utils'

import { FeedbotMiddleware, isThunk } from './types'
import { collapseRootDialogWithAllSubdialogs } from './utils'
import { appActions } from './app'
import { isTabOfType } from '../features/botHeaderTabs'
import { BotHeaderTab, BotHeaderTabType } from '../features/botHeaderTabs/types'
import { isLaunchingSelector } from './socketServer'
import { botsApi } from '../features/serverBots/api/botsApi'
import { ServerApiTag } from './serverApi'
import { openBotIdSelector } from './app/selectors'
import { botFlowSelector } from './flow/selectors/botFlowSelector'
import { validateSsmlInFlowThunk } from '../features/flowValidation'

const sideEffectsMiddleware: FeedbotMiddleware =
  ({ dispatch, getState }) =>
  next =>
  action => {
    if (isThunk(action)) {
      return next(action)
    }

    if (action.type === appActions.closeTabs.type) {
      const dialogIds = (action.payload as BotHeaderTab[])
        .filter(isTabOfType(BotHeaderTabType.Dialog))
        .map(({ id }) => id)
        .filter(isNotEmptyElement)

      dialogIds.forEach(dialogId => {
        dispatch(collapseRootDialogWithAllSubdialogs(dialogId))
      })
    }

    const botId = openBotIdSelector(getState())
    if (!botId) {
      return next(action)
    }

    const state = getState()
    const result = next(action)
    const nextState = getState()

    if (isLaunchingSelector(state) && !isLaunchingSelector(nextState)) {
      dispatch(botsApi.util.invalidateTags([ServerApiTag.BOT_CONFIG(botId)]))
    }

    if (botFlowSelector(state)?.version !== botFlowSelector(nextState)?.version) {
      dispatch(validateSsmlInFlowThunk(false))
    }

    return result
  }

export default sideEffectsMiddleware
